import Vue from "vue";
import Router from "vue-router";
//import store from "./store";

import Layout from "./components/DefaultLayout.vue";

// DASHBOARD
import Dashboard from "./views/Dashboard/Dashboard.vue";
// LOGIN
import Login from "./views/Login/Login.vue";
import Register from "./views/Login/register.vue";
import Emobile from "./views/Login/emobile.vue";
//import HomePage from "./views/Login/HomePage.vue";
import MainPage from "./views/Login/mainPage.vue";
import List from "./views/Login/list.vue";
import HeaderFooter from "./views/Login/headerFooter.vue";
import ContactUs from "./views/Login/contactUs.vue";
import ViewHotelDetails from "./views/Login/viewHotelDetails.vue";
import ReviewBooking from "./views/Login/reviewBooking.vue";
import DestinationMenu from "./views/Login/destinationmenu.vue";
import DestinationInter from "./views/Login/destionationInter.vue";
import Success from "./views/Login/success.vue";
import Fail from "./views/Login/fail.vue";
import AboutUs from "./views/Login/aboutUs.vue";
import Management from "./views/Login/management.vue";
import PaymentSecurity from "./views/Login/paymentSecurity.vue";
import PrivacyPolicy from "./views/Login/privacyPolicy.vue";
import TermsUse from "./views/Login/termsUse.vue";
import ThemePackage from "./views/Login/themePackage.vue";
import DestinationPackage from "./views/Login/destinationPackage.vue";
import DestinationPackageInt from "./views/Login/destinationPackageInt.vue";
import PackageDetails from "./views/Login/packageDetails.vue";
import BlogPage from "./views/Login/blogPage.vue";
import BlogDetails from "./views/Login/blogDetails.vue";
import Gallery from "./views/Login/gallery.vue";
import Packages from "./views/Login/packages.vue";


import _ViewHotelDetails from "./views/Login/_viewHotelDetails.vue";
import _ReviewBooking from "./views/Login/_reviewBooking.vue";
//import Test from "./views/Login/Test.vue";

// Company
import Company from "./views/Company/company.vue";
import EditCompany from "./views/Company/editCompany.vue";

// USER
import User from "./views/Users/user.vue";
import EditUser from "./views/Users/editUser.vue";
import CreateUser from "./views/Users/createUser.vue";
// USER -> CHANGE PASSWORD
import ChangePassword from "./views/Users/changePassword.vue";
// USER -> EDIT USER PROFILE

//TOURTHEME
import TourTheme from "./views/TourTheme/tourTheme.vue";
import CreateTourTheme from "./views/TourTheme/createTourTheme.vue";
import EditTourTheme from "./views/TourTheme/editTourTheme.vue";
import ImageTourTheme from "./views/TourTheme/imageTourTheme.vue";


//DESTINATION
import Destination from "./views/Destination/destination.vue";
import CreateDestination from "./views/Destination/createDestination.vue";
import EditDestination from "./views/Destination/editDestination.vue";
import ImageDestination from "./views/Destination/imageDestination.vue";

//COUNTRYSTATECITY
import CountryStateCity from "./views/CountryStateCity/countryStateCity.vue";
import CreateState from "./views/CountryStateCity/createState.vue";
import CreateCity from "./views/CountryStateCity/createCity.vue";
import EditState from "./views/CountryStateCity/editState.vue";
import EditCity from "./views/CountryStateCity/editCity.vue";

//DESTINATION
import PlacesVisit from "./views/PlaceVisit/placesVisit.vue";
import CreatePlacesVisit from "./views/PlaceVisit/createPlacesVisit.vue";
import EditPlacesVisit from "./views/PlaceVisit/editPlacesVisit.vue";
import ImagePlacesVisit from "./views/PlaceVisit/imagePlacesVisit.vue";

//INCLUSIONEXCLUSIONOPTIONAL
import InclusionExclusionOptional from "./views/InclusionExclusionOptional/inclusionExclusionOptional.vue";
import CreateInclusion from "./views/InclusionExclusionOptional/createInclusion.vue";
import CreateExclusion from "./views/InclusionExclusionOptional/createExclusion.vue";
import CreateOptional from "./views/InclusionExclusionOptional/createOptional.vue";
import EditInclusion from "./views/InclusionExclusionOptional/editInclusion.vue";
import EditExclusion from "./views/InclusionExclusionOptional/editExclusion.vue";
import EditOptional from "./views/InclusionExclusionOptional/editOptional.vue";


//DESTINATION
import BookingPolicy from "./views/BookingPolicy/bookingPolicy.vue";
import CreateBookingPolicy from "./views/BookingPolicy/createBookingPolicy.vue";
import EditBookingPolicy from "./views/BookingPolicy/editBookingPolicy.vue";


//TOURPACKAGE
import TourPackage from "./views/TourPackage/tourPackage.vue";
import CreateTourPackage from "./views/TourPackage/createTourPackage.vue";
import EditTourPackage from "./views/TourPackage/editTourPackage.vue";
import Itinerary from "./views/TourPackage/itinerary.vue";
import CreateItinerary from "./views/TourPackage/createItinerary.vue";
import CreatePackageInclusion from "./views/TourPackage/createPackageInclusion.vue";
import EditPackageInclusion from "./views/TourPackage/editPackageInclusion.vue";
import EditPackageExclusion from "./views/TourPackage/editPackageExclusion.vue";
import EditPackageOptional from "./views/TourPackage/editPackageOptional.vue";
import EditPackageBooking from "./views/TourPackage/editPackageBooking.vue";
import CreatePackageExclusion from "./views/TourPackage/createPackageExclusion.vue";
import CreatePackageOptional from "./views/TourPackage/createPackageOptional.vue";
import CreatePackageBooking from "./views/TourPackage/createPackageBooking.vue";
import ImageTourPackage from "./views/TourPackage/imageTourPackage.vue";
import ViewTourPackage from "./views/TourPackage/viewTourPackage.vue";
import EditItinerary from "./views/TourPackage/editItinerary.vue";
import ViewItinerary from "./views/TourPackage/viewItinerary.vue";

//MYPROFILE
import MyProfile from "./views/MyProfile/myProfile.vue";
import EditMyProfile from "./views/MyProfile/editMyProfile.vue";

//MYBLOG
import MyBlog from "./views/MyBlog/myBlog.vue";
import CreateMyBlog from "./views/MyBlog/createMyBlog.vue";
import EditMyBlog from "./views/MyBlog/editBlog.vue";
import ViewMyBlog from "./views/MyBlog/viewBlog.vue";
import ImageMyBlog from "./views/MyBlog/imageBlog.vue";
import VideoMyBlog from "./views/MyBlog/videoBlog.vue";

//ENQUIRY
import Enquiry from "./views/Enquiry/enquiry.vue";
import ViewEnquiry from "./views/Enquiry/viewEnquiry.vue";

import Bookings from "./views/Bookings/bookings.vue";
import Bookingdetail from "./views/Bookings/bookingdetail.vue";
Vue.use(Router);

const router = new Router({

  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  
  // mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: HeaderFooter,
      children: [
        {
          path: "",
          redirect: "/main",
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/main",
          name: "MainPage",
          component: MainPage,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/destinationmenu",
          name: "Destinationmenu",
          component: DestinationMenu,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/destinationInter",
          name: "DestinationInter",
          component: DestinationInter,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/themePackage/:id",
          name: "ThemePackage",
          component: ThemePackage,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/destinationPackage/:id",
          name: "DestinationPackage",
          component: DestinationPackage,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/destinationPackageInt/:id",
          name: "DestinationPackageInt",
          component: DestinationPackageInt,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/packageDetails/:id",
          name: "PackageDetails",
          component: PackageDetails,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/blogPage",
          component: BlogPage,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/blogDetails/:id",
          component: BlogDetails,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/gallery",
          component: Gallery,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/packages",
          component: Packages,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/list",
          name: "List",
          component: List,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/contactUs",
          component: ContactUs,
          meta: {
            transitionName: 'slide'
          }
        },
        {
          path: "/aboutUs",
          component: AboutUs,
          meta: {
            transitionName: 'slide'
          }
        },
        {
          path: "/management",
          component: Management,
          meta: {
            transitionName: 'slide'
          }
        },
        {
          path: "/paymentSecurity",
          component: PaymentSecurity,
          meta: {
            transitionName: 'slide'
          }
        },
        {
          path: "/privacyPolicy",
          component: PrivacyPolicy,
          meta: {
            transitionName: 'slide'
          }
        },
        {
          path: "/termsUse",
          component: TermsUse,
          meta: {
            transitionName: 'slide'
          }
        },
        {
          path: "/viewHotelDetails/:id",
          component: ViewHotelDetails,
          meta: {
            transitionName: 'slide'
          }
        },
        //=====
        {
          path: "/_viewHotelDetails/:id",
          component: _ViewHotelDetails,
          meta: {
            transitionName: 'slide'
          }
        },
        {
          path: "/viewHotelDetails/reviewBooking/:id",
          component: ReviewBooking,
          meta: {
            transitionName: 'slide'
          }
        },
        //=====
        {
          path: "/_viewHotelDetails/_reviewBooking/:id",
          component: _ReviewBooking,
          meta: {
            transitionName: 'slide'
          }
        },
      ]
    },
    {
      path: "/login",
      component: Login,
      meta: {
        transitionName: 'slide'
      }
    },
    {
      path: "/register",
      component: Register,
      meta: {
        transitionName: 'slide'
      }
    },
    {
      path: "/emobile",
      component: Emobile,
      meta: {
        transitionName: 'slide'
      }
    },
    /* {
      path: "/aimro",
      component: MainPage
    }, */
    
    {
      path: "/success",
      component: Success,
      meta: {
        transitionName: 'slide'
      }
    },
    {
      path: "/fail",
      component: Fail,
      meta: {
        transitionName: 'slide'
      }
    },
    
    {
      path: "/",
      component: Layout,
      meta: {
        requiresAuth: true,
        transitionName: 'slide'
      },
      children: [
        {
          path: "/_",
          component: Dashboard,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        // COMPANY
        {
          path: "/company",
          component: Company,
          meta: {
            requiresAuth: true,
            transitionName: 'slide'
          }
        },
        {
          path: "/editCompany/:id",
          component: EditCompany,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
       
        // USER
        {
          path: "/user",
          component: User,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createUser",
          component: CreateUser,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editUser/:id",
          component: EditUser,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/changePassword/:id",
          component: ChangePassword,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/tourTheme",
          component: TourTheme,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createTourTheme",
          component: CreateTourTheme,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editTourTheme/:id",
          component: EditTourTheme,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/imageTourTheme/:id",
          component: ImageTourTheme,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/destination",
          component: Destination,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createDestination",
          component: CreateDestination,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editDestination/:id",
          component: EditDestination,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/imageDestination/:id",
          component: ImageDestination,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/countryStateCity",
          component: CountryStateCity,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createState",
          component: CreateState,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createCity",
          component: CreateCity,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editState/:id",
          component: EditState,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editCity/:id",
          component: EditCity,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/placesVisit",
          component: PlacesVisit,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createPlacesVisit",
          component: CreatePlacesVisit,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editPlacesVisit/:id",
          component: EditPlacesVisit,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/imagePlacesVisit/:id",
          component: ImagePlacesVisit,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/inclusionExclusion",
          component: InclusionExclusionOptional,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createInclusion",
          component: CreateInclusion,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createExclusion",
          component: CreateExclusion,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createOptional",
          component: CreateOptional,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editInclusion/:id",
          component: EditInclusion,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editExclusion/:id",
          component: EditExclusion,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editOptional/:id",
          component: EditOptional,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/bookingPolicy",
          component: BookingPolicy,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createBookingPolicy",
          component: CreateBookingPolicy,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editBookingPolicy/:id",
          component: EditBookingPolicy,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/tourPackage",
          component: TourPackage,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createTourPackage",
          component: CreateTourPackage,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editTourPackage/:id",
          component: EditTourPackage,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/itinerary/:id",
          component: Itinerary,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createItinerary/:id",
          component: CreateItinerary,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createPackageInclusion/:id",
          component: CreatePackageInclusion,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editPackageInclusion/:id",
          component: EditPackageInclusion,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editPackageExclusion/:id",
          component: EditPackageExclusion,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editPackageOptional/:id",
          component: EditPackageOptional,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editPackageBooking/:id",
          component: EditPackageBooking,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createPackageExclusion/:id",
          component: CreatePackageExclusion,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createPackageOptional/:id",
          component: CreatePackageOptional,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createPackageBooking/:id",
          component: CreatePackageBooking,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/imageTourPackage/:id",
          component: ImageTourPackage,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/viewTourPackage/:id",
          component: ViewTourPackage,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/itinerary/editItinerary/:id",
          component: EditItinerary,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/itinerary/viewItinerary/:id",
          component: ViewItinerary,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/myProfile",
          component: MyProfile,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editMyProfile/:id",
          component: EditMyProfile,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/myBlog",
          component: MyBlog,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/createMyBlog",
          component: CreateMyBlog,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/editMyBlog/:id",
          component: EditMyBlog,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/viewMyBlog/:id",
          component: ViewMyBlog,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/imageMyBlog/:id",
          component: ImageMyBlog,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/videoMyBlog/:id",
          component: VideoMyBlog,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/enquiry",
          component: Enquiry,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/viewEnquiry/:id",
          component: ViewEnquiry,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/bookings",
          component: Bookings,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        {
          path: "/booking-detail/:id",
          component: Bookingdetail,
          meta: {
            requiresAuth: true,
            transitionName: "slide"
          }
        },
        
        
      ]
    }
  ]
});
/* router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    next("/aimro");
  } else {
    next();
  }
}); */

export default router;
